export default __webpack_public_path__ + "static/media/404.ca48f4fd.png";